export default __webpack_public_path__ + "static/socaves-6f38a9093e164b872bde6f13cdae7bda.jpg";